<template>
  <div class="container">
    <div class="wrap box-con">
      <div class="order-info">
        <div class=" z-flex z-flex-between">
          <div class="order-num z-flex"><i class="el-icon-position"></i>创建新的修图订单<span v-if="activeStep==2&&selPsPackIdx>=0">，可修{{psPackList[selPsPackIdx].num}}张</span></div>
        </div>
      </div>
      <div class="imgs-con">
        <el-steps :active="activeStep" align-center>
          <el-step title="选择修图包" description="请选择您的修图包"></el-step>
          <el-step title="上传图片" description="上传图片并添加修图备注"></el-step>
          <el-step title="提交成功" description="等待修图老师安排修图"></el-step>
        </el-steps>
        <div class="step-con step-con-1" v-if="activeStep==1">
          <div class="hd">请选择您的修图包或者购买新的修图包：</div>
          <div class="bd z-flex">
            <div :class="['item',selPsPackIdx==index?'active':'']" v-for="(item,index) in psPackList" :key="index" @click="selPsPack(item,index)">
              <div class="title">{{item.title}}</div>
              <div class="num">剩余{{item.num}}张</div>
              <div class="time">{{item.time}}购买</div>
              <i class="el-icon-success" v-if="selPsPackIdx==index"></i>
            </div>
            <div class="item item-buy z-flex z-flex-col z-flex-center" @click="toUrl('/ps/pack')">
              <i class="el-icon-goods"></i>
              <p>购买新修图包</p>
            </div>
          </div>
          <div class="btn-group z-flex z-flex-center">
            <el-button @click="toUrl('/ps/index')">返回</el-button>
            <el-button type="primary" @click="toUpload">下一步</el-button>
          </div>
        </div>
        <div class="step-con step-con-2" v-if="activeStep==2">
          <div class="upload-con">
            <div class="item z-flex">
              <div class="label">上传图片：</div>
              <div class="item-r">
                <el-upload
                  action=""
                  list-type="picture-card"
                  :file-list="fileList"
                  multiple
                  :limit="upLimit"
                  :accept="upAccept"
                  :auto-upload="true"
                  :on-change="handleChange"
                  :before-upload="handleBeforeUpload"
                  :http-request="handleHttpRequest"
                  :on-remove="handleRemove"
                  :on-exceed="handleExceed"
                >
                    <i slot="default" class="el-icon-plus"></i>
                </el-upload>
              </div>
            </div>
            <div class="item z-flex">
              <div class="label">需求描述：</div>
              <div class="item-r">
                <el-input
                  type="textarea"
                  :rows="5"
                  maxlength="500"
                  show-word-limit
                  placeholder="请输入修图需求信息"
                  v-model="requirement">
                </el-input>
              </div>
            </div>
          </div>
          <div class="btn-group z-flex z-flex-center">
            <el-button @click="activeStep=1">上一步</el-button>
            <el-button type="primary" @click="toSubmit">提交订单</el-button>
          </div>
        </div>
        <div class="step-con step-con-3" v-if="activeStep==3">
          <el-result icon="success" title="修图订单下单成功">
            <template slot="extra">
              <div class="ex-text">修图老师正在努力修图中，订单完成后将用登录手机或微信进行提醒，</div>
              <div class="ex-text">也可以随时通过“个人中心-我的修图”查看当前修图进度。</div>
            </template>
          </el-result>
          <div class="btn-group z-flex z-flex-center">
            <el-button @click="activeStep=1">继续修图</el-button>
            <el-button type="primary" @click="toUrl('/my/ps')">查看我的修图</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    
  },
  data() {
    return {
      activeStep:1,
      psPackList:[],
      fileList:[],
      requirement:'',
      selPsPackIdx:-1,
      upAccept: 'image/jpeg,image/gif,image/png,image/tiff',
      // upAccept: '*',
      upLimit: 1
    };
  },
  computed: {
    
  },
  mounted() {
    this.init();
  },
  methods: {
    init(){
      this.fileList = [];
      this.selPsPackIdx = -1;
      this.requirement = '';
      this.$axios.api.userPsList({}, (res) => {
        if (res.code == 200) {
          this.psPackList = res.data.list;
        }
      })
    },
    toUrl(url){
      this.$router.push({
        path:url,
      })
    },
    selPsPack(item,index){
      this.selPsPackIdx = index;
      this.upLimit = item.num;
    },
    toUpload(){
      if (this.selPsPackIdx < 0) {
        return this.$message.error("请选择修图包");
      }
      this.activeStep = 2;
    },
    toSubmit(){
      let params = {
        userps_id: this.psPackList[this.selPsPackIdx].id,
        images: [],
        remark: this.requirement,
      }
      for (var i=0; i < this.fileList.length; i++) {
        if (this.fileList[i].raw.ossurl) {
          params.images.push(this.fileList[i].raw.ossurl);
        }
      }
      if (params.images.length != this.fileList.length) {
        return this.$message.error("图片上传中，请稍后");
      }
      this.$axios.api.createPsOrder(params, (res) => {
        if (res.code == 200) {
          this.init();
          this.activeStep = 3;
        }
      })
    },
    /**
     * 选择文件后生成MD5并且获取oss直传密钥
     * @param file
     * @param filelist
     */
    handleChange(file, filelist) {
      if (file.status == 'ready') {
        file.raw.thumburl = file.url;
        var ext = file.name.substring(file.name.lastIndexOf('.') + 1);
        var acceptExt = /^(bmp|jpg|jpeg|gif|png|webp)/i;
        if (!acceptExt.test(ext)) {
          //非常规格式，dcraw解析
          this.$helper.extractThumb(file, (resf) => {
            console.log("非常规格式----", resf);
            this.updatePictureCard('src', resf.url, resf.raw.thumburl);
          });
        }
      }
      this.fileList.push(file);
    },
    /**
     * 上传之前的校验
     * @param file
     * @returns {boolean|boolean}
     */
    handleBeforeUpload(file) {
      this.upAccept = this.upAccept.toLowerCase();
      let isImage = this.upAccept.indexOf(file.type.toLowerCase()) >= 0;
      let isSize = file.size / 1024 / 1024 < 100;
      if (this.upAccept == '' || this.upAccept == '*') {
        isImage = true;
      }
      if (!isImage) {
        this.$message.error("请上传指定的图片格式["+this.upAccept+"]!");
      } else if (!isSize) {
        this.$message.error("上传文件大小不能超过 100MB!");
      }
      return isImage && isSize;
    },
    /**
     * 上传到OSS
     * @param opt
     */
    handleHttpRequest(opt) {
      this.$helper.getFileMd5(opt.file, (fileMd5) => {
        //上传到OSS
        opt.file.md5 = fileMd5;
        opt.file.process = 0;
        this.uploadOss(opt.file, (file) => {
          opt.file.process = 1;//标记为上传完成
          this.updatePictureCard('success', file.thumburl, '1');
          // console.log("上传成功!!!!!", file)
        })
      });
    },
    handleRemove(file, fileList) {
      let idx = this.fileList.indexOf(file.url);
      this.fileList.splice(idx, 1);
    },
    handleExceed(files, fileList) {
      this.$message.error(`最多允许上传 ${this.upLimit} 张`);
    },
    //阿里云直传
    uploadOss(file, callback){
      let fileName = file.name;
      this.$axios.api.aliossParams({name: fileName, md5: file.md5}, (resa) => {
        if (resa.code == 200) {
          //阿里云前端直传
          var patt = /^\/\//;
          resa.data.host = (patt.test(resa.data.host) ? 'https:' : '') + resa.data.host;
          var ossform = new FormData();
          ossform.append("name", fileName);
          ossform.append("key", resa.data.key);
          ossform.append("policy", resa.data.policy);
          ossform.append("OSSAccessKeyId", resa.data.OSSAccessKeyId);
          ossform.append("success_action_status", resa.data.success_action_status);
          ossform.append("signature", resa.data.signature);
          ossform.append("callback", resa.data.callback);
          ossform.append("host", resa.data.host);
          ossform.append("file", file, fileName);
          this.$axios.post(resa.data.host, ossform, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }).then(res => {
            if (res.status == 200) {  //上传成功
              file.ossurl = resa.data.host + "/" + resa.data.key;
              callback(file);
              // this.$message.success("上传成功!")
            } else {
              this.$message.error("上传失败，请重新尝试!");
            }
          }).catch(error => {
            console.log("alioss错误: ", error);
          })
        }
      })
    },
    //预览图状态
    updatePictureCard(action, url, value) {
      var elimgs = document.querySelectorAll(".el-upload-list__item-thumbnail");
      for (var i = 0; i < elimgs.length; i++) {
        if (elimgs[i].getAttribute('src') == url) {
          if (action == 'success') {
            var child = document.createElement('div');
            child.append("上传完成");
            elimgs[i].parentElement.insertBefore(child, elimgs[i]);
          } else if (action == 'src') {
            elimgs[i].setAttribute('src', value);
          }
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.box-con{
  padding: 20px 40px;
}
.order-info{
  color: #999;
  font-size: 15px;
  .order-num{
    font-size: 22px;
    color: #333;
    i{
      margin-right: 6px;
      font-size: 25px;
    }
  }
  .title{
    margin-top: 15px;
  }
  .tips{
    margin-top: 20px;
  }
}

.imgs-con{
  border-top: $borderDashed;
  padding-top: 20px;
  margin-top: 20px;
  
}
.step-con{
  margin-top: 60px;
  padding: 30px 60px;
  .btn-group{
    margin-top: 50px;
  }
}
.step-con-1{
  .bd{
    margin-top: 30px;
  }
  .item{
    width:300px;
    height:130px;
    padding: 15px;
    box-sizing: border-box;
    border: $border;
    border-radius: 6px;
    margin: 0 20px 20px 0;
    cursor: pointer;
    position: relative;
    .title{
      @extend %textOverflow;
      margin-bottom: 10px;
    }
    .num{
      font-size: 14px;
      color: #777;
      margin-bottom: 15px;
    }
    .time{
      text-align: right;
      font-size: 15px;
      color: #999;
      padding-top: 10px;
      border-top: $borderDotted;
    }
    .el-icon-success{
      color: $colorMain;
      font-size: 18px;
      position:absolute;
      right: 8px;
      top: 8px;
    }
    &:hover{
      color: $colorMain;
      border-color: $colorMain;
    }
    &.active{
      color: $colorMain;
      border-color: $colorMain;
    }
  }
  .item-buy{
    color: $colorMain;
    border-color: $colorMain;
    i{
      font-size: 26px;
      margin-bottom: 10px;
    }
  }
}
.step-con-2{
  .item{
    margin-bottom: 30px;
    .item-r{
      flex:1;
      margin-left: 30px;
    }
  }
}
.step-con-3{
  .ex-text{
    color: #999;
    font-size: 14px;
  }
}
</style>
